module.exports = __webpack_public_path__ + "img/allowgeo.7b09b3c8.jpg";